<template>
  <div class="pinwall__add" ref="addPost" :style="setScroll">
    <section>
      <!-- <b-field
        :label="`Name (${name.length}/30)`"
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
      >
        <b-input v-model="name" name="name" v-validate="'max:30'" />
      </b-field>-->
      <b-field :label="$t('text.name')">
        <TextEditor
          v-if="renderTextEditor"
          :text="text"
          @update="textUpdated"
        ></TextEditor>
      </b-field>

      <!-- <b-field label="Text">
        <b-input maxlength="200" v-model="text" type="textarea"></b-input>
      </b-field> -->
      <b-field :label="$t('searchContent.name')">
        <SearchInput
          @input="showSearchModal"
          :placeholder="$t('searchContent.placeholder')"
        ></SearchInput>
      </b-field>

      <b-modal :active.sync="isModalActive">
        <Search
          @add="setSearchItem"
          @select="setSearchItem"
          :search="search"
          :tenantId="tenantId"
        />
      </b-modal>

      <b-modal :active.sync="isQuizModalActive">
        <AddQuiz :quiz="this.quiz" @save="setQuiz" />
      </b-modal>

      <b-modal :active.sync="isPollModalActive">
        <AddPoll :poll="this.poll" @save="setPoll" />
      </b-modal>

      <div v-if="mediaPreview" class="media-content">
        <Video
          v-if="video"
          :post="mediaPreview"
          :autoplay="false"
          playsinline
        />
        <img
          v-else-if="mediaPreview.image"
          :src="mediaPreview.image.source"
          @click="$emit('fullscreen', item)"
        />
      </div>

      <b-field :label="$t('filesUpload.name')">
        <FileInput
          :id="id"
          ref="fileInput"
          @fileUploading="fileUploading = true"
          @fileUploaded="uploaded"
        />
      </b-field>

      <!-- <LinkInput @change="linksChanged" /> -->
      <label>Module</label>
      <div class="module-container">
        <div class="module" @click="isQuizModalActive = !isQuizModalActive">
          <i :class="!this.quiz ? 'mdi mdi-plus' : 'mdi mdi-pencil'"></i>
          {{ $t("module.quiz") }}
        </div>
        <div class="module" @click="isPollModalActive = !isPollModalActive">
          <i :class="!this.poll ? 'mdi mdi-plus' : 'mdi mdi-pencil'"></i>
          {{ $t("module.poll") }}
        </div>
      </div>

      <b-field :label="$t('pickColor.name')">
        <ColorPicker @input="setColor"></ColorPicker>
      </b-field>

      <button
        :disabled="fileUploading || pendingFiles > 0"
        type="submit"
        @click="validateBeforeSubmit"
        :class="
          fileUploading || pendingFiles > 0
            ? 'button is-success is-rounded action-button is-loading'
            : 'button is-success is-rounded action-button'
        "
      >
        {{ $t("save.name") }}
      </button>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { generateId } from "../../utils/helpers";
import FileInput from "./FileInput";
import Search from "./Search";
import Video from "./Video";
import AddQuiz from "../quiz/Add.vue";
import AddPoll from "../poll/Add.vue";
// import LinkInput from "./LinkInput";
import SearchInput from "../core/SearchInput";
import TextEditor from "../core/TextEditor";
import ColorPicker from "../core/ColorPicker";
import { setScroll } from "../../mixins/setScroll.js";

export default {
  name: "add",
  props: {
    tenantId: {
      type: String
    },
    pinwallId: {
      type: String
    },
    password: {
      type: String
    },
    view: {
      type: String
    },
    sort: {
      type: String
    }
  },
  data() {
    return {
      id: generateId(),
      name: "",
      search: "",
      text: "",
      linked: false,
      quiz: null,
      poll: null,
      url: "",
      style: "",
      links: [],
      multiUpload: false,
      mediaPreview: null,
      proportion: 0,
      renderTextEditor: true,
      pendingFiles: 0,
      isModalActive: false,
      isQuizModalActive: false,
      isPollModalActive: false,
      clientHeight: 0,
      addFromSearch: false,
      fileUploading: false
    };
  },
  components: {
    FileInput,
    TextEditor,
    Search,
    Video,
    SearchInput,
    ColorPicker,
    AddQuiz,
    AddPoll
  },
  mixins: [setScroll],
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["createPost"]),
    uploaded(files) {
      this.fileUploading = false;
      this.image = files.image;
      this.video = files.video;
      this.audio = files.audio;
      this.proportion = files.proportion;
      this.file = files.file;
      this.pendingFiles = files.pendingFiles;
      this.addFromSearch = false;
      if (this.pendingFiles > 0 || this.multiUpload) {
        this.multiUpload = true;
        this.create();
      }
    },
    textUpdated(value) {
      this.text = value;
    },
    setColor(color) {
      if (color === "#000000" || color === "#262626") {
        this.style = `background-color: ${color};color: #d3c9c9`;
      } else {
        this.style = `background-color: ${color}`;
      }
    },
    linksChanged(links) {
      this.links = [];
      links.map(link => {
        if (link.url && link.url !== "") {
          this.proportion =
            this.proportion == 0 || link.proportion < this.proportion
              ? link.proportion
              : this.proportion;
          const found = this.links.find(item => {
            return item.url === link.url;
          });
          if (!found) {
            this.links.push(link);
          }
        }
      });
    },
    setQuiz(quiz) {
      this.quiz = quiz;
      this.isQuizModalActive = false;
    },
    setPoll(poll) {
      this.poll = poll;
      this.isPollModalActive = false;
    },
    setSearchItem(item) {
      if (item.post) {
        this.text = item.post.text;
        this.image = item.post.image;
        this.style = item.post.style;
        this.links = item.post.links;
        this.video = item.post.video;
        this.audio = item.post.audio;
        this.linked = true;
        this.proportion = item.post.proportion;
      } else {
        this.video = item.video || null;
        this.image = item.image || null;
        this.proportion = item.proportion;
        this.text = item.title;
      }

      if (item.action === "add") {
        this.addFromSearch = true;
        this.create();
      } else {
        this.mediaPreview = {
          video: this.video,
          playMedia: true,
          image: this.image
        };
        this.isModalActive = false;
        this.renderTextEditor = false;
        this.$nextTick(() => {
          this.renderTextEditor = true;
        });
      }
    },
    create() {
      this.createPost({
        id: this.id,
        pinwallId: this.pinwallId,
        name: this.user ? this.user.userName : null,
        text: this.text,
        image: this.image,
        quiz: this.quiz,
        poll: this.poll,
        style: this.style,
        links: this.links,
        video: this.video,
        audio: this.audio,
        file: this.file,
        linked: this.linked,
        proportion: this.proportion,
        view: this.view
      }).then(data => {
        var emitModel = {
          postList: data,
          view: this.view,
          windowWidth: this.windowWidth,
          sort: this.sort
        };

        this.$socket.emit(
          process.env.VUE_APP_SOCKET_ON,
          this.pinwallId + (this.password || ""),
          emitModel
        );
        this.id = generateId();
        if (this.pendingFiles > 0) {
          this.$refs.fileInput.uploadNextFile();
        } else if (!this.addFromSearch) {
          this.$emit("added");
        } else {
          this.text = "";
          this.multiUpload = false;
          this.proportion = 0;
        }
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$buefy.toast.open({
            message: this.$t("form.isValid"),
            type: "is-success",
            position: "is-top-right"
          });
          this.create();
          return;
        }
        this.$buefy.toast.open({
          message: this.$t("form.notValid"),
          type: "is-danger",
          position: "is-top-right"
        });
      });
    },
    showSearchModal(value) {
      this.search = value;
      this.isModalActive = true;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.clientHeight = this.$refs.addPost.clientHeight;
    });
  }
};
</script>
